import { Navigate, useRoutes } from "react-router";
import { useSearchParams } from "react-router-dom";
import { ProtectedRoutes } from "./utils/protectedRoutes";

import AuthLayout from "./layout/Auth/authLayout";
import WelcomeLayout from "./layout/Welcome/welcome";

import Landing from "./pages/Landing/landing";
import Jobs from "./pages/Header/jobs";
import LandingJobDetails from "./pages/Header/landingJobDetails";

import Register from "./pages/Auth/Register/registerRedesign";
import Welcome from "./pages/Auth/Welcome/welcomeRedesign";
import Login from "./pages/Auth/Login/loginRedesign";
import ResetPassword from "./pages/Auth/ResetPassword/resetPasswordRedesign";
import UpdatePassword from "./pages/Auth/UpdatePassword/updatePassword";

import TalentDashboard from "./layout/TalentDashboard/dashboard";
import TalentLayout from "./layout/TalentOnboarding/talentOnboardingRedesign";
import ClientDashboard from "./layout/ClientDashboard/dashboard";
import ClientLayout from "./layout/ClientOnboarding/clientOnboarding";

import ClientStage1 from "./pages/ClientOnboarding/Stage1/stage1";
import ClientStage2 from "./pages/ClientOnboarding/Stage2/stage2";
import ClientStage3 from "./pages/ClientOnboarding/Stage3/stage3";
import ClientStage4 from "./pages/ClientOnboarding/Stage4/stage4";
import ClientReview from "./pages/ClientOnboarding/Review/review";

import TalentStage1 from "./pages/TalentOnboarding/Stage1Redesign/stage1";
import TalentStage2 from "./pages/TalentOnboarding/Stage2Redesign/stage2";
import TalentStage3 from "./pages/TalentOnboarding/Stage3Redesign/stage3";
import TalentStage4 from "./pages/TalentOnboarding/Stage4Redesign/stage4";
import TalentStage5 from "./pages/TalentOnboarding/Stage5Redesign/stage5";
import TalentStage6 from "./pages/TalentOnboarding/Stage6Redesign/stage6";
import TalentStage7 from "./pages/TalentOnboarding/Stage7/Stage7";

import ClientJobs from "./pages/ClientDashboard/Jobs/jobs";
import NewJob from "./pages/ClientDashboard/NewJob/newJob";
import AddNewJob from "./pages/ClientDashboard/AddNewJob/newJob";
import JobFeed from "./pages/TalentDashboard/JobFeed/feedRedesign";
import ProfileReview from "./pages/TalentDashboard/Profile/profile";
import ProfileReport from "./pages/TalentDashboard/Profile/ProfileReport";
import Matches from "./pages/TalentDashboard/Matches/matchesRedesign";
import ClientProfile from "./pages/ClientDashboard/Profile/profile";
import Verify from "./pages/Auth/Verify/verifyRedesign";
import CompanyProfile from "./pages/ClientDashboard/CompanyProfile/profile";
import Error404 from "./pages/Error/404";
import TalentSettings from "./pages/TalentDashboard/Settings/settingsRedesign";
import TalentMedia from "./pages/TalentDashboard/Media/media";

import Report from "./pages/Report";
import ReportBehavior from "./pages/Report/ReportBehavior/report";
import ContactUs from "./pages/Report/ContactUs/contact";
import LogABug from "./pages/Report/LogABug/logabug";

import AdvancedSearch from "./pages/TalentDashboard/AdvancedSearch/searchRedesign";
import Feed from "./pages/ClientDashboard/Feed/Feed";
import TalentProfile from "./pages/ClientDashboard/TalentProfile/TalentProfile";
import JobDetails from "./pages/TalentDashboard/JobDetails/JobDetails";
import TermsAndPolicyLayout from "./layout/TermsAndPolicyLayout/TermsAndPolicyLayout";
import TermsOfService from "./pages/TermsAndPolicy/TermsOfService";
import PrivacyPolicy from "./pages/TermsAndPolicy/PrivacyPolicy";
import TalentReview from "./pages/TalentOnboarding/Review/review";
import SelfDevelopment from "./pages/TalentDashboard/SelfDevelopment/SelfDevelopment";
import Team from "./pages/Team/team";
import Waitlist from "./pages/Waitlist/waitlist";
import TalentMessages from "./pages/Messages/TalentMessages/messagesRedesign";
import TeamManagement from "./pages/ClientDashboard/TeamManagement/teamManagement";
import TalentActivitySummary from "./pages/TalentActivitySummary/TalentActivitySummary";
import ClientJobDetails from "./components/viewJobDetails/ViewJobDetails";
import SubscriptionPayment from "./pages/ClientDashboard/SubscriptionPayment/subscriptionPayment";
import SupportPage from "./pages/NonUserSupport/SupportPage"; //
import ClientActivitySummary from "./pages/ClientActivitySummary/ClientActivitySummary";
import Test from "./pages/TalentDashboard/Test/testRedesign";
import { UserContext } from "./context";
import { useContext } from "react";
import ContactUsPage from "./pages/ContactUs/contact";
import AwaAIPage from "./pages/AwaAI/awaAI";
import AiInsights from "./pages/TalentDashboard/AiInsights/AiInsights";
import LandingPage from "./pages/Landing/LandingPage";
import PaymentPage from "./pages/Payment/PaymentPage";
import FeaturesPage from "./pages/Features/FeaturesPage";
import TalentLandingPage from "./pages/TalentLanding/TalentLanding";
import Dashboard from "./pages/TalentDashboard/Dashboard/dashboard";
import TalentSupportCentre from "./pages/TalentDashboard/Support/support";
import ClientSupportPage from "./pages/Report/report";
import AwaSourcePricing from "./components/Landing/components/Pricing/NewPricing/AwasourcePricing";
import APIPage from "./pages/APIIntegrations/APIPage";
import PartnerLanding from "./pages/PartnerLanding/PartnerLanding";
import PartnerLogin from "./pages/PartnerPortal/partnerLogin";
import PartnerPortal from "./pages/PartnerPortal/partnerPortal";
import CandidateAssessment from "./pages/CandidateAssessment/CandidateAssessment";
import CandidateEnroll from "./pages/CandidateAssessment/Enroll";
import PartnerRevealKey from "./pages/PartnerPortal/RevealKey";
import PartnerAcceptInvitePage from "./pages/PartnerPortal/AcceptInvite";
import { ForgotPassword as PartnerForgotPassword, ResetPassword as PartnerResetPassword } from "./pages/PartnerPortal/PartnerPassword";
import PartnerPortalDashboard from "./pages/PartnerPortal/views/Dashboard";
import CheckoutPage from "./components/Landing/components/Checkout/CheckoutPage";
import ClientMessagesRedesign from "./pages/Messages/ClientMessages/ClientMessagesRedesign";
import AcceptInvite from "./pages/Auth/AcceptInvite/AcceptInvite";
import Usage from "./pages/PartnerPortal/views/Usage";
import Sessions from "./pages/PartnerPortal/views/Sessions";
import CandidateFit from "./pages/PartnerPortal/views/CandidateFit";
import Webhooks from "./pages/PartnerPortal/views/Webhooks";
import Billing from "./pages/PartnerPortal/views/Billing";
import Flow from "./pages/PartnerPortal/views/Flow";
import Docs from "./pages/PartnerPortal/views/Docs";
import Settings from "./pages/PartnerPortal/views/Settings";
import ApiKeys from "./pages/PartnerPortal/views/ApiKeys";

const Routes = () => {
  const [param] = useSearchParams();
  // Emails and notifications link to /talent-onboarding without a stage. The wizard
  // picks its step from this param, so with none it rendered the progress bar and an
  // empty body; fall back to the first stage.
  const talentStage = param.get("stage") || "1";
  // const { isDev } = useContext(UserContext);

  return useRoutes([
    { path: "/", element: <LandingPage /> },
    { path: "/features", element: <FeaturesPage /> },
    { path: "/api-integrations", element: <APIPage /> },
    { path: "/partners", element: <PartnerLanding /> },
    { path: "/partner-login", element: <PartnerLogin /> },
    { path: "/assessment/:sessionId", element: <CandidateAssessment /> },
    { path: "/enroll/:token", element: <CandidateEnroll /> },
    { path: "/portal/reveal", element: <PartnerRevealKey /> },
    { path: "/portal/accept-invite", element: <PartnerAcceptInvitePage /> },
    { path: "/portal/forgot", element: <PartnerForgotPassword /> },
    { path: "/portal/reset", element: <PartnerResetPassword /> },
    { path: "/talents", element: <TalentLandingPage /> },
    { path: "/register", element: <Register /> },
    { path: "/login", element: <Login /> },
    { path: "/verify-mail", element: <Verify /> },
    { path: "/reset-password", element: <ResetPassword /> },
    { path: "/support", element: <SupportPage /> },
    { path: "/contact-us", element: <ContactUsPage /> },
    { path: "/pricing", element: <AwaSourcePricing /> },
    { path: "/checkout", element: <CheckoutPage /> },
    { path: "/awa-ai", element: <AwaAIPage /> },
    { path: "/talent/payment-success", element: <PaymentPage /> },
    { path: "/talent-profile/report", element: <ProfileReport /> },
    { path: "/accept-invite", element: <AcceptInvite /> },

    {
      path: "/",
      element: <AuthLayout />,
      children: [
        {
          path: "/auth/password/reset-password/:token",
          element: <UpdatePassword />,
        },
      ],
    },
    {
      path: "/welcome",
      element: <Welcome />,
    },
    {
      path: "/talent-onboarding",
      element: (
        <TalentLayout>
          {talentStage === "1" && <TalentStage1 />}
          {talentStage === "2" && <TalentStage2 />}
          {talentStage === "3" && <TalentStage3 />}
          {talentStage === "4" && <TalentStage4 />}
          {talentStage === "5" && <TalentStage5 />}
          {talentStage === "6" && <TalentStage6 />}
          {talentStage === "7" && <TalentStage7 />}
          {talentStage === "8" && <TalentReview />}
        </TalentLayout>
      ),
    },

    { path: "/jobs", element: <Jobs /> },
    { path: "/job-details/:jobId", element: <LandingJobDetails /> },
    {
      path: "/client-onboarding",
      element: (
        <ClientLayout>
          {param.get("stage") === "1" && <ClientStage1 />}
          {param.get("stage") === "2" && <ClientStage2 />}
          {param.get("stage") === "3" && <ClientStage3 />}
          {param.get("stage") === "4" && <ClientStage4 />}
          {param.get("stage") === "5" && <ClientReview />}
        </ClientLayout>
      ),
    },
    {
      path: "/",
      element: <ClientDashboard />,
      children: [
        { path: "/client/feed", element: <Feed /> },
        { path: "/client-jobs", element: <ClientJobs /> },
        { path: "/client-jobs/:id", element: <ClientJobDetails /> },
        { path: "/company-profile", element: <CompanyProfile type="client" /> },
        { path: "/team-management", element: <TeamManagement /> },
        { path: "/client-messages", element: <ClientMessagesRedesign /> },
        { path: "/personal-profile", element: <ClientProfile /> },
        { path: "/add-new-job/gig", element: <AddNewJob jobType="Gig" /> },
        { path: "/add-new-job/job", element: <AddNewJob jobType="Job" /> },
        { path: "/add-new-job", element: <NewJob /> },
        { path: "/client-report", element: <ClientSupportPage /> },
        { path: "/analytics", element: <Feed /> },
        {
          path: "/client-activity-summary",
          element: <ClientActivitySummary />,
        },
        { path: "/talent", element: <Feed /> },
        { path: "/subscription-payment", element: <SubscriptionPayment /> },
        {
          path: "/client-report-behaviour",
          element: ProtectedRoutes(ReportBehavior),
        },
        { path: "/client-contact-us", element: ProtectedRoutes(ContactUs) },
        { path: "/client-report-a-bug", element: ProtectedRoutes(LogABug) },
        {
          path: "/talent-profile/review/:id",
          element: <TalentProfile type={"client"} />,
        },
      ],
    },

    {
      path: "/",
      element: <TalentDashboard />,
      children: [
        { path: "/talent-dashboard", element: <Dashboard /> },
        { path: "/talent-support", element: <TalentSupportCentre /> },
        { path: "/media", element: ProtectedRoutes(TalentMedia) },
        { path: "/search", element: ProtectedRoutes(AdvancedSearch) },
        { path: "/job-feed", element: <JobFeed /> },
        { path: "/job/:id", element: <JobDetails /> },
        { path: "/talent-messages", element: <TalentMessages /> },
        { path: "/matches", element: ProtectedRoutes(Matches) },
        { path: "/talent-report", element: ProtectedRoutes(Report) },
        { path: "/ai-insights", element: ProtectedRoutes(AiInsights) },
        {
          path: "/talent-activity-summary",
          element: ProtectedRoutes(TalentActivitySummary),
        },
        {
          path: "/talent-report-behaviour",
          element: ProtectedRoutes(ReportBehavior),
        },
        { path: "/talent-contact-us", element: ProtectedRoutes(ContactUs) },
        { path: "/talent-report-a-bug", element: ProtectedRoutes(LogABug) },
        { path: "/talent-settings", element: <TalentSettings /> },
        { path: "/self-development", element: <SelfDevelopment /> },
        {
          path: "/view-company/:id",
          element: <CompanyProfile type="talent" />,
        },
        { path: "/test", element: <Test /> },
        {
          path: "/talent-profile",
          element: <ProfileReview type={"talent"} />,
        },
      ],
    },

    {
      path: "partner",
      element: <PartnerPortal />,
      children: [
        { index: true, element: <Navigate to="/partner/dashboard" replace /> },
        {
          path: "dashboard",
          element: <PartnerPortalDashboard />,
        },
        {
          path: "api-keys",
          element: <ApiKeys />,
        },
        {
          path: "usage",
          element: <Usage />,
        },
        {
          path: "sessions",
          element: <Sessions />,
        },
        {
          path: "candidate-fit",
          element: <CandidateFit />,
        },
        {
          path: "webhooks",
          element: <Webhooks />,
        },
        {
          path: "billing",
          element: <Billing />,
        },
        {
          path: "how-it-works",
          element: <Flow />,
        },
        {
          path: "docs",
          element: <Docs />,
        },
        {
          path: "settings",
          element: <Settings />,
        },
      ],
    },

    {
      path: "/*",
      element: (
        <WelcomeLayout>
          <Error404 />,
        </WelcomeLayout>
      ),
    },
    {
      path: "/",
      element: <TermsAndPolicyLayout />,
      children: [
        { path: "/terms-of-service", element: <TermsOfService /> },
        { path: "/privacy-policy", element: <PrivacyPolicy /> },
      ],
    },
    {
      path: "/team",
      element: <Team />,
    },
    {
      path: "/waitlist",
      element: <Waitlist />,
    },
  ]);
};

export default Routes;
